import { render, staticRenderFns } from "./table-chars.vue?vue&type=template&id=bd39d2ae&scoped=true"
import script from "./table-chars.vue?vue&type=script&lang=ts"
export * from "./table-chars.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd39d2ae",
  null
  
)

export default component.exports